import shortcutRegistry from '.';

declare global {
    interface Window {
        // eslint-disable-next-line @typescript-eslint/naming-convention
        ShortcutRegistry: typeof shortcutRegistry | null;
    }
}

window.ShortcutRegistry = shortcutRegistry;
